module.exports = __webpack_public_path__ + "static/media/ic_promoted_yellow.54288b14.svg";